module.exports = __webpack_public_path__ + "static/img/1.ac1c66b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/1.png
// module id = hWvy
// module chunks = 0